import { useCallback } from 'react';
import { useApolloClient } from 'react-apollo';
import gql from 'graphql-tag';

import type {
	GetConfluenceSpacesQuery,
	GetConfluenceSpacesQueryVariables,
} from './gql/__types__/GetConfluenceSpaceQuery.ts';

interface MapConfluenceSpaceKeysToIdsProps {
	setQueryParamsCallback: (params: any, replace?: boolean) => void;
	queryParams: Record<string, any>;
}

export const useGetSpaceIdsFromSpaceKeys = ({
	setQueryParamsCallback,
	queryParams,
}: MapConfluenceSpaceKeysToIdsProps) => {
	const apolloClient = useApolloClient();

	const getSpaceIdsFromSpaceKeys = useCallback(
		async (spaceKeys: string[]): Promise<string[]> => {
			if (spaceKeys.length === 0) return [];
			try {
				// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
				const query = await apolloClient.query<
					GetConfluenceSpacesQuery,
					GetConfluenceSpacesQueryVariables
				>({
					query: gql`
						query useGetSpaceIdsFromSpaceKeysQuery($spaceKeys: [String]) {
							spaces(spaceKeys: $spaceKeys) {
								nodes {
									id
								}
							}
						}
					`,
					variables: {
						spaceKeys,
					},
				});
				const spaceIds: string[] = (query.data.spaces?.nodes ?? [])
					.map((node) => node?.id)
					.filter((id): id is string => !!id);
				return spaceIds;
			} catch {
				// TODO: log error using what Confluence uses in place of Sentry
				//	likely in follow up ticket

				// drop the spaces query param
				setQueryParamsCallback(
					{
						...queryParams,
						spaces: undefined,
					},
					true,
				);
			}
			return [];
		},
		[apolloClient, queryParams, setQueryParamsCallback],
	);
	return getSpaceIdsFromSpaceKeys;
};
